import { useEffect, useState } from "react";
import { adminApi, getAdminToken } from "../../lib/api";

/**
 * Whether the current viewer is an authenticated admin (has a valid /admin bearer
 * token in this browser). Used to reveal admin-only affordances — e.g. the clip
 * focus editor — inside the otherwise user-facing control app. Validated once per
 * page load and cached module-wide.
 */
let cached: boolean | null = null;

export function useIsAdmin(): boolean {
  const [admin, setAdmin] = useState(cached ?? false);

  useEffect(() => {
    if (cached !== null) {
      setAdmin(cached);
      return;
    }
    if (!getAdminToken()) {
      cached = false;
      setAdmin(false);
      return;
    }
    let cancelled = false;
    adminApi
      .session()
      .then(() => {
        cached = true;
        if (!cancelled) setAdmin(true);
      })
      .catch(() => {
        cached = false;
        if (!cancelled) setAdmin(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return admin;
}
